import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  extends: BaseSiteFactorData,
  props: {
    site: {
      required: true,
      type: Object
    },
    auditSiteDevice: {
      required: true,
      type: Object
    },
    auditTime: {
      required: true,
      type: String
    }
  },
  data () {
    let {auditTime} = this

    return {
      query: {
        beginTime: `${auditTime} 00:00:00`,
        endTime: `${auditTime} 23:59:59`
      }
    }
  },
  computed: {
    completeAllData: () => true,
    otherSiteDeviceCategoryConfigs: () => [],
    currentSiteDevice () {
      return this.profileSiteDeviceMap[this.auditSiteDevice.id]
    },
    filterDeviceInfo () {
      let siteId = this.site.id
      let otherSiteDeviceCategoryConfigMap = this.otherSiteDeviceCategoryConfigs.reduce((map, siteDeviceCategoryConfig) => {
        map[siteDeviceCategoryConfig.categoryId] = siteDeviceCategoryConfig
        return map
      }, {})

      return {
        devices: [...this._profileSiteDevices.filter(siteDevice => siteDevice.siteId === siteId && otherSiteDeviceCategoryConfigMap[siteDevice.categoryId]), this.currentSiteDevice]
      }
    },
    profileSiteDevices () {
      return this.filterDeviceInfo.devices
    },
    siteDeviceCategoryConfig () {
      return [
        ...this.otherSiteDeviceCategoryConfigs,
        new DeviceCategoryConfig(this.currentSiteDevice.categoryId, true, this.filterCurrentSiteDeviceFactors)
      ]
    }
  },
  methods: {
    filterCurrentSiteDeviceFactors: siteDeviceFactors => siteDeviceFactors,
    getData () {
      this.changeLoadStatus(true)
      let {conditions} = this
      let currentQuery = JSON.parse(JSON.stringify(this.currentQuery))
      currentQuery.beginTime = conditions.beginTime
      currentQuery.endTime = conditions.endTime
      currentQuery.isGetInvalidData = false
      this.$api.Data.getHistoryData(currentQuery).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  watch: {
    auditTime (auditTime) {
      let {query} = this
      query.beginTime = `${auditTime} 00:00:00`
      query.endTime = `${auditTime} 23:59:59`
      this.afterSetSiteIds()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/02Data-Audit/01Manual/AuditDeviceViews/BaseCompare.js